<template>
    <DanhSachLogTrongApp/>
</template>
<script>
import DanhSachLogTrongApp from "@/components/pages/quan-tri-he-thong/log/DanhSachLogTrongApp";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";
export default {
    name: "TrangDanhSachLog",
    components:{
        DanhSachLogTrongApp,
    },
    created() {
    setBreadcrumb(
      `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NAME} / ${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.LOG.NAME
      }`
    );
  }
}
</script>